import React from 'react'
import ExpenseSettings from 'src/app/ExpenseSettings/ExpenseSettings'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseSettingsRouteProps } from 'src/navigation/routeProps'

const ExpenseSettingsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseSettings,
  routeProps: expenseSettingsRouteProps,
  component: <ExpenseSettings />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseSettingsAppRoute
